<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
          <!-- <i class="material-icons cusIconSize">&#xE7FD;</i> -->
          <img src="./assets/images/Location_Setting_Icon.png" alt="" />
          <span>Notification Accounts</span>
        </p>
      </div>
      <md-card>
        <md-card-content>

          <form class="example-form" [formGroup]="form">
            <div class="col s12 m4 l4" *ngIf="searchRegionShow">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Region" mdInput formControlName="searchRegionControl" [mdAutocomplete]="region" [showDropDown]="{model: 'region', scope : this }">
                  <md-autocomplete #region="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of (regionFilteredOptions | async)" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
              </div>
            </div>
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Location" mdInput formControlName="searchLocationControl" [mdAutocomplete]="location" [showDropDown]="{model: 'location', scope : this }">
                  <md-autocomplete #location="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of (locationFilteredOptions | async)" [value]="option" class="subOptionShow">
                      <span>
                        {{ option.name }}
                        <span title="{{ option.locationAddress }}" class="locationListAddressCls">
                          <br/>{{ option.locationAddress }}</span>
                      </span>
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
              </div>
            </div>
          </form>
          <div *ngIf="form.controls.searchLocationControl && form.controls.searchLocationControl.value && form.controls.searchLocationControl.value.id && form.controls.searchLocationControl.value.id>0"
            class="col s12 m12 l12">
            <!-- locationName - Address -->
            <div class="userAccountAddressInfo">
              <p><span>Selected Location:</span> {{ form.controls.searchLocationControl.value.name + ' - '+ form.controls.searchLocationControl.value.locationAddress
                }}
              </p>
            </div>
          </div>
        </md-card-content>
      </md-card>

      <md-card class="setting-card" *ngIf="form.controls.searchLocationControl && form.controls.searchLocationControl.value && form.controls.searchLocationControl.value.id && form.controls.searchLocationControl.value.id>0">
        <!-- <md-card> -->


        <md-card-content>

          <md-card-title>
            <div class="admPageHeading">
              <p>
                <span>Notification Account for Site Specific Updates</span>
              </p>
            </div>
          </md-card-title>

          <form id="koalaForm" class="kolaConfigurationPopup" novalidate [formGroup]="userListForm">
            <div class="row">
              <ul #perfectScrollSection class="kolaConfigTbCls customScrollKoala">
                <li *ngFor="let groupIndex of userListItemGroupIndex;let i = index;">
                  <div formGroupName="{{groupIndex}}">
                    <div class="kolaFieldCls errorZoneSec">
                      <md-form-field class="example-full-width">
                        <input mdInput placeholder="First Name" formControlName="firstName" maxlength="100">
                      </md-form-field>
                      <p requiredField *ngIf="userListForm.controls[groupIndex].controls.firstName.touched && userListForm.controls[groupIndex].controls.firstName.invalid"></p>
                    </div>
                    <div class="kolaFieldCls errorZoneSec">
                      <md-form-field class="example-full-width">
                        <input mdInput placeholder="Last Name" formControlName="lastName" maxlength="100">
                      </md-form-field>
                      <p requiredField *ngIf="userListForm.controls[groupIndex].controls.lastName.touched && userListForm.controls[groupIndex].controls.lastName.errors && userListForm.controls[groupIndex].controls.lastName.errors.required"></p>
                    </div>
                    <div class="kolaFieldCls errorZoneSec">
                      <md-form-field class="example-full-width">
                        <input mdInput placeholder="Email" formControlName="email" maxlength="200">
                      </md-form-field>
                      <p requiredField *ngIf="userListForm.controls[groupIndex].controls.email.touched && userListForm.controls[groupIndex].controls.email.errors
                       && userListForm.controls[groupIndex].controls.email.errors.required;else invalidEmail"></p>
                      <ng-template #invalidEmail>
                        <p class="validate" *ngIf="userListForm.controls[groupIndex].controls.email.touched && userListForm.controls[groupIndex].controls.email.errors && userListForm.controls[groupIndex].controls.email.errors.pattern">Incorrect Email Format</p>
                      </ng-template>
                    </div>
                  </div>
                  <div class="kolaAddDelBtn">
                    <button md-icon-button [mdMenuTriggerFor]="menu">
                      <md-icon>more_vert</md-icon>
                    </button>
                    <md-menu #menu="mdMenu">
                      <button md-menu-item (click)="onAdd(groupIndex, perfectScrollSection)">
                        <span>Add</span>
                      </button>
                      <button md-menu-item (click)="onDelete(groupIndex, perfectScrollSection)">
                        <span>Delete</span>
                      </button>
                    </md-menu>
                  </div>
                </li>

              </ul>
              <div class="button-row">
                <button [disabled]="userListForm.invalid" md-raised-button class="glbAdminBtnCls1" (click)="addNominees(perfectScrollSection)">ADD NOMINEE</button>
              </div>
            </div>
          </form>

          <!-- <div class="col s12 m8 l8">
            <div class="button-row">              
              <button md-raised-button class="glbAdminBtnCls1 bigBtn" (click)="addNominees()">
                <i class="material-icons">&#xE145;</i> ADD NOMINEE</button>
            </div>
          </div> -->


        </md-card-content>
      </md-card>


      <!-- grid code -->
      <div class="cusPaginationContainer example-container mat-elevation-z8" *ngIf="nominateUsersPaginationInfo && nominateUsersPaginationInfo.totalRecords == 0">
        <p class="nodataFound"> No Results Found</p>
      </div>
      <div class="cusPaginationContainer example-container mat-elevation-z8" [ngClass]="{'hide-grid':nominateUsersPaginationInfo && nominateUsersPaginationInfo.totalRecords == 0 }">
        <md-table class="manageSiteAdminListTable" #table [dataSource]="dataSource" mdSort>

          <md-header-row *mdHeaderRowDef="displayedColumns"></md-header-row>
          <md-row *mdRowDef="let row; columns: displayedColumns;"></md-row>

          <!--- Note that these columns can be defined in any order. The actual rendered columns are set as a property on the row definition" -->
          <!-- First Name Column -->
          <ng-container mdColumnDef="firstName">
            <md-header-cell *mdHeaderCellDef md-sort-header>FIRST NAME</md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.firstName }} </md-cell>
          </ng-container>

          <!-- Last name Column -->
          <ng-container mdColumnDef="lastName">
            <md-header-cell *mdHeaderCellDef md-sort-header> LAST NAME </md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.lastName}} </md-cell>
          </ng-container>

          <!-- Email Column -->
          <ng-container mdColumnDef="email">
            <md-header-cell *mdHeaderCellDef md-sort-header> EMAIL </md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.email}} </md-cell>
          </ng-container>

          <!-- Action Column -->
          <ng-container mdColumnDef="Action">
            <md-header-cell *mdHeaderCellDef>ACTIONS</md-header-cell>
            <md-cell *mdCellDef="let element">
              <a href="javascript:void(0);" (click)="removeNominee(element.id)">Remove</a>
            </md-cell>
          </ng-container>
        </md-table>
        <md-paginator #paginator [length]="nominateUsersPaginationInfo.totalRecords" [pageIndex]="0" [pageSize]="dataSource.initialPageSize"
          [pageSizeOptions]="dataSource.pageSizeOptions" (page)="dataSource.onPaginateChange(appUrl.getNominee,$event,this,remotePaginationParams)">
        </md-paginator>
      </div>
      <!-- grid code end -->

    </div>
  </div>
</section>


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-nominate-users-location-updates/adm-nominate-users-location-updates.component.html